var shared = require('./shared')
module.exports = function(html) {
  return shared(html, document)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/mkdom/browser.js
 ** module id = 475
 ** module chunks = 0
 **/